(function ($) {
  $(function () {
    //Razor Nav
    var $stickyEl = $(".js-site-navigation"),
      $body = $("body"),
      $stickyElPosition = $stickyEl.position(),
      $stickyElHeight = $stickyEl.outerHeight(),
      $mainHeader = $(".js-site-header"),
      $siteSearch = $(".js-header-site-search"),
      fixedHeaderBreakPoint = 950,
      $stickyMobNav = $(".site-header__mobile-tools"),
      $stickyMobNavPosition = $stickyMobNav.position(),
      $stickyMobNavHeight = $stickyMobNav.outerHeight(),
      $promoBanner = $(".promo-fixed");

    // allow child themes to override the fixed header breakpoint
    if (
      window.universityPressThemeSettings.fixed_header_breakpoint !==
      "undefined"
    ) {
      fixedHeaderBreakPoint =
        window.universityPressThemeSettings.fixed_header_breakpoint;
    }

    if ($(window).width() >= fixedHeaderBreakPoint) {
      $(window).on("scroll", function () {
        if (typeof $stickyElPosition === "undefined") {
          return;
        }
        var boundingBox = $stickyEl[0].getBoundingClientRect();
        var position = $(this).scrollTop();

        if ($promoBanner && !localStorage.getItem("popupClosed")) {
          var $promoBannerHeight = $promoBanner.outerHeight();
          if (boundingBox.top <= $promoBannerHeight) {
            $stickyEl.css("top", $promoBannerHeight);
            $stickyEl.addClass("fixed-nav");
          } else {
            $stickyEl.css("top", "");
          }
        }

        if (position >= $stickyElPosition.top) {
          $body.addClass("fixed-header");
          $stickyEl.addClass("fixed-nav");
          $siteSearch.addClass("fixed-nav");
          $mainHeader.css("paddingBottom", $stickyElHeight);
          $siteSearch.css("top", $stickyElHeight);
        } else {
          $body.removeClass("fixed-header");
          $stickyEl.removeClass("fixed-nav");
          $siteSearch.removeClass("fixed-nav");
          $mainHeader.removeAttr("style");
          $siteSearch.removeAttr("style");
        }
      });
    }

    function mobFixedNav() {
      if (typeof $stickyMobNavPosition === "undefined") {
        return;
      }

      var $position = $(this).scrollTop(),
        $promoBannerHeight = $promoBanner.outerHeight();

      if ($promoBannerHeight > 0 && !localStorage.getItem("popupClosed")) {
        $mobSearchTop = $promoBannerHeight + $stickyMobNavHeight;
      } else {
        $mobSearchTop = $stickyMobNavHeight;
      }

      if ($promoBanner && !localStorage.getItem("popupClosed")) {
        if ($position >= $stickyMobNavPosition.top) {
          $stickyMobNav.css("top", $promoBannerHeight);
          $stickyMobNav.addClass("fixed-nav-mob");
        } else {
          $stickyMobNav.css("top", "");
          $stickyMobNav.removeClass("fixed-nav-mob");
        }
      } else {
        if ($position >= $stickyMobNavPosition.top) {
          $stickyMobNav.addClass("fixed-nav-mob");
        } else {
          $stickyMobNav.removeClass("fixed-nav-mob");
        }
      }
    }

    if ($(window).width() < fixedHeaderBreakPoint) {
      $(window).on("scroll resize", function () {
        mobFixedNav();
      });
    }
  });
})(jQuery);
